import { Grid, Typography } from '@material-ui/core';
import React from 'react';

function TextLabel({ id, label, value, map, format }) {
  return (
    <Grid item xs={12}>
      <label htmlFor={`label-${id}`}>
        <b>{label}</b>
      </label>
      {!Array.isArray(value) ? (
        <RawValue id={id} value={value} format={format} />
      ) : (
        <ArrayValue id={id} value={value} map={map} format={format} />
      )}
    </Grid>
  );
}

function RawValue({ id, value, format }) {
  let textValue = value && format ? format(value) : value;
  if (typeof textValue === 'number') {
    textValue = `${textValue}`;
  }

  const titleProps = typeof textValue !== 'object' ? { title: textValue } : {};

  return (
    <Typography noWrap id={id} {...titleProps}>
      {textValue || '-'}
    </Typography>
  );
}

function ArrayValue({ id, value, map, format }) {
  return (
    <div>
      {value && value.length
        ? value.map((v, i) => {
            return (
              <div key={i}>
                <RawValue id={id} value={v && map ? v[map] : v} format={format} />
              </div>
            );
          })
        : '-'}
    </div>
  );
}

TextLabel.defaultProps = {};
export default TextLabel;
